module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('h1', [_vm._v("优仓官网管理系统")]), _vm._v(" "), _c('div', {
    staticClass: "header-right"
  }, [_c('span', {
    staticClass: "span-icon-loginout"
  }), _vm._v(" "), _c('span', {
    staticClass: "span-icon-message"
  }), _vm._v(" "), _c('span', {
    staticClass: "span-text"
  }, [_vm._v("小强")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76aca7f7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/header.vue
// module id = 124
// module chunks = 1